import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
import {SESSION_DATA, user,} from "../../../constants";
// import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { currentIp } from "../../../constants";
import { DegreeSpecialization, DomainSubDomain ,tpfMember} from "../../../data/TableData";


const AddEditShift = () => {
  const navigate = useNavigate();
  // const { id } = useParams();
//   const { SESSION_DATA, user } = useSelector((state) => state.user);
const shiftNumber = [1,2,3,4];
  const [addUpdate, setAddUpdate] = useState(false);
  




  const [submitForm, errorSubmit, loadingSubmit, axiosSubmitUser] =
    useAxios();
  const [formGetShift, errorGetShift, loadingGetShift, axiosGetShift] =
    useAxios();

  const FETCH_API_URL = "master/getShiftData";
  const SUBMIT_FORM_DATA_URL = `master/createShifts`;

    const getShifts = (url) => {
      axiosGetShift({
          axiosInstance: axiosInstance,
          url: url,
          method: "GET",
        });
      };
useEffect(() => {
  getShifts(FETCH_API_URL)
},[FETCH_API_URL]);

useEffect(()=>{
  if(formGetShift !==undefined && formGetShift !== null){
    formGetShift?.[0]?.ShiftData?.map((fetchShift,index)=>{
     
setValue(`shiftName_${index}`,fetchShift?.shiftName);
setValue(`shiftStartTime_${index}`,fetchShift?.shiftStartTime);
setValue(`shiftEndTime_${index}`,fetchShift?.shiftEndTime);
setValue(`slotTime_${index}`,fetchShift?.slotTime);
    })
  }


},[formGetShift])

console.log("formGetShift",formGetShift)


  const form = useForm({
    defaultValues: {
      
    },
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;




  

  const onFormSubmit = async (data) => {
let getShiftArray = [];
    for (let numRow = 0; numRow < shiftNumber.length; numRow++) {
      getShiftArray.push({
        shiftName: data[`shiftName_${numRow}`],
        shiftStartTime: data[`shiftStartTime_${numRow}`],
        shiftEndTime: data[`shiftEndTime_${numRow}`],
        slotTime: data[`slotTime_${numRow}`],
        status: data[`status_${numRow}`],
      });
    }
console.log("getShiftArray",getShiftArray);

    const toTitleCase = (str) => {
      return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
        return match.toUpperCase();
      });
    };
console.log("data=", data)
    let formData = {
      shiftData : getShiftArray
     
    };

    await axiosSubmitUser({
      axiosInstance: axiosInstance,
      url: SUBMIT_FORM_DATA_URL,
      method: "POST",
      requestConfig: {
        data: formData,
      },
    });

    setAddUpdate(true);
  };
  useEffect(() => {
    if (errorSubmit) {
      toast.error(
        `Your information could not be !!error:${errorSubmit}`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    } else if (addUpdate) {
      toast.success(
        "Updated successfully !!",
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
    }
  }, [loadingSubmit, errorSubmit]);

  return (
    <>
      <div className="card min-height-100">
        <div className="card-title flex-row">
          <h2 className="text-navyBlue">Manage Shift </h2>
          {/* <Link to="/master/shiftListing">
            <button className="btn btn-blue rounded-10">Back</button>
          </Link> */}
        </div>
        <ToastContainer />

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
            <div className="col-md-3  tank-col-info">
                <label htmlFor="name" className="text-gray text-semi-bold">
                  Shift Name<span className="text-red">*</span>
                </label>
               
              </div>
            <div className="col-md-3  tank-col-info">
                <label htmlFor="name" className="text-gray text-semi-bold">
                  Shift Start Time<span className="text-red">*</span>
                </label>
               
              </div>
            <div className="col-md-3  tank-col-info">
                <label htmlFor="name" className="text-gray text-semi-bold">
                  Shift End Time<span className="text-red">*</span>
                </label>
               
              </div>
            <div className="col-md-3  tank-col-info">
                <label htmlFor="name" className="text-gray text-semi-bold">
                  Slot Time (in minutes)<span className="text-red">*</span>
                </label>
               
              </div>
              {
                shiftNumber?.map((fetchSlot,index) => (
                  <>
                   <div className="col-md-3  tank-col-info">
               
               <input
                 id={`shiftName_${index}`}
                 {...register(`shiftName_${index}`, {
                   required: {
                     value: true,
                     message: "Shift Name is required",
                   },
                   
                 })}
                 type="text"
                 className="form-control rounded-10 mb-15"
                 placeholder="Enter Shift Name"
                 disabled= {true}
               />
               <p className="text-red">{errors?.[`shiftName_${index}`]?.message}</p>
             </div>
           <div className="col-md-3  tank-col-info">
              
               <input
                 id={`shiftStartTime_${index}`}
                 {...register(`shiftStartTime_${index}`, {
                   required: {
                     value: true,
                     message: "Shift Start Time Field is required",
                   },
                  
                 })}
                 type="time"
                 className="form-control rounded-10 mb-15"
                 
               />
               <p className="text-red">{errors?.[`shiftStartTime_${index}`]?.message}</p>
             </div>
           <div className="col-md-3  tank-col-info">
              
               <input
                 id={`shiftEndTime_${index}`}
                 {...register(`shiftEndTime_${index}`, {
                   required: {
                     value: true,
                     message: "Shift End Time is Required",
                   },
                  
                 })}
                 type="time"
                 className="form-control rounded-10 mb-15"
                 
               />
               <p className="text-red">{errors?.[`shiftEndTime_${index}`]?.message}</p>
             </div>
           <div className="col-md-3  tank-col-info">
              
               <input
                   id={`slotTime_${index}`}
                 {...register(`slotTime_${index}`, {
                   required: {
                     value: true,
                     message: "Slot Time is required",
                   },
                  
                 })}
                 type="text"
                 placeholder="Enter Slot Time "
                 className="form-control rounded-10 mb-15"
                 
               />
               <input
                   id={`status_${index}`}
                 {...register(`status_${index}`, {
                   required: {
                     value: true,
                    
                   },
                  
                 })}
                 type="hidden"
                value = "A"
                 
               />
               <p className="text-red">{errors?.[`slotTime_${index}`]?.message}</p>
             </div>
                  </>

                ))
              }
           
            
             
             
              
             
             
           
             
        
            
            

              <div className="col-md-12 text-center ">
                <input
                  type="submit"
                  className="btn btn-secondary rounded-10"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>

       
      </div>
    </>
  );
};

export default AddEditShift;
